'use client'

import { Logo } from '@/components/sections/logo'
import { Link } from '@/components/ui/deprecated-link'
import { MainRoutes } from '@/utils/routes'
import Image from 'next/image'
import { useEffect } from 'react'
import NextLink from 'next/link'
import posthog from 'posthog-js'
/**
 * https://nextjs.org/docs/app/api-reference/file-conventions/not-found
 */
export default function NotFound() {
  useEffect(() => {
    posthog.captureException('not-found', {
      level: 'warning',
      extra: {
        pathname: window.location.pathname,
      },
    })
    console.warn('[POSTHOG_DETECTION_ID]:not-found')
  }, [])

  return (
    <>
      <div className="p-4 border-b border-border-divider">
        <div className="max-w-screen-2xl mx-auto">
          <NextLink href={MainRoutes.Home} prefetch={false}>
            <Logo hasName priority />
          </NextLink>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
        <div className="flex flex-col items-center max-w-xl gap-6">
          <Image
            src="/assets/icons/question-mark.svg"
            alt=""
            width={64}
            height={64}
            className="w-20 h-20 dark:hidden"
          />
          <Image
            src="/assets/icons/question-mark-dark.svg"
            alt=""
            width={64}
            height={64}
            className="w-20 h-20 hidden dark:block"
          />
          <div>
            <h1 className="text-3xl font-bold text-copy-primary mb-2">
              Oops! Looks like you’re lost
            </h1>

            <p className="text-copy-accent">
              The page you’re looking for doesn’t exist. <br />
              You may want to check for typos in the URL or go back to “Home.”
            </p>
          </div>
          <Link variant="primaryButton" href={MainRoutes.Home}>
            Back to Home
          </Link>
        </div>
      </div>
    </>
  )
}
